import React from 'react';
import { Star, MapPin } from 'lucide-react';
import VendorPerformanceBadge from './VendorPerformanceBadge';

const VendorKeyDetails = ({ vendor, servicesCount }) => {
  if (!vendor) return null;

  const details = [];

  // Performance score (platform bookings)
  if (vendor?.performance_score > 0 && vendor?.platform_bookings_count > 0) {
    details.push(
      <VendorPerformanceBadge
        key="performance"
        score={vendor.performance_score}
        bookingsCount={vendor.platform_bookings_count}
        size="md"
      />
    );
  }

  // Rating
  if (vendor?.average_rating) {
    details.push(
      <div key="rating" className="flex items-center gap-1.5">
        <Star className="w-4 h-4 text-black fill-current" />
        <span className="font-medium text-black">{vendor.average_rating}</span>
        <span className="text-gray-600">
          · {vendor.total_reviews || 0} {vendor.total_reviews === 1 ? 'review' : 'reviews'}
        </span>
      </div>
    );
  }

  // Location
  if (vendor?.city && vendor?.state) {
    details.push(
      <div key="location" className="flex items-center gap-1.5 text-gray-600">
        <MapPin className="w-4 h-4" />
        <span>{vendor.city}, {vendor.state}</span>
      </div>
    );
  }

  // Service count
  if (servicesCount > 0) {
    details.push(
      <span key="services" className="text-gray-600">
        {servicesCount} {servicesCount === 1 ? 'service' : 'services'}
      </span>
    );
  }

  if (details.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-base">
      {details.map((detail, index) => (
        <React.Fragment key={index}>
          {index > 0 && <span className="text-gray-300">·</span>}
          {detail}
        </React.Fragment>
      ))}
    </div>
  );
};

export default VendorKeyDetails;

